import React, { useState, useEffect } from "react";
import closeBtnIcon from "../../assets/img/x.webp";
import kalenderIcon from "../../assets/img/kalender_icon.webp";
import locationIcon from "../../assets/img/standort_icon.webp";
import themeIcon from "../../assets/img/Themen_Icon.webp";
import EventForm from "./Forms/EventForm";

function EventModal({ Props, Actions, closeModalFunction }) {
  const [activePageIndex, setActivePageIndex] = useState(0);
  const [activePage, setActivePage] = useState([]);
  const maxPageIndex = 2;
  const closeModal = Actions["closeModal"];
  const isOverBooked = false;

  useEffect(
    (closeModal) => {
      const onBtnInfoClick = () => {
        if (activePageIndex < maxPageIndex) {
          setActivePageIndex(activePageIndex + 1);
        } else {
          closeModalFunction();
        }
      };

      const RenderInfoPage = () => {
        return (
          <>
            <h1 className="modal-event-heading fw-bold">
              Veranstaltungsanmeldung
            </h1>
            <div className="modal-event-sub-heading">
              <h2>5. Dialogreihe MiWi Lausitz</h2>
            </div>

            <div className="modal-event-info">
              {isOverBooked ? (
                <>
                  <p className="modal-event-info-text">
                    Die Veranstaltung ist derzeit ausgebucht. Bei Interesse
                    haben Sie selbstverständlich die Möglichkeit, sich über das
                    Anmeldeformular für einen Wartelistenplatz anzumelden.
                  </p>
                  <br />
                  <p> Vielen Dank für Ihr Verständnis.</p>
                </>
              ) : (
                <>
                  <div className="modal-event-info-wrapper">
                    <img
                      className="modal-icon"
                      src={kalenderIcon}
                      alt="kalender"
                    />
                    <p className="modal-event-info-text">
                      25.03.2026, ab 14:30 Uhr
                    </p>
                  </div>
                  <div className="modal-event-info-wrapper">
                    <img
                      className="modal-icon"
                      src={locationIcon}
                      alt="standort"
                    />
                    <div className="modal-event-info-address">
                      <span>Zur Waldhufe</span>
                      <span>Hotel & Restaurant</span>
                      <span>Waldhufenstraße 55</span>
                      <span>03253 Doberlug-Kirchhain</span>
                    </div>
                  </div>
                </>
              )}

              <div className="modal-event-infolist-wrapper">
                {/* 
                <img className="modal-icon" src={themeIcon} alt="themen" />
                <ul className="modal-event-infolist">
                  <li>
                    Weitere Informationen zur Themenauswahl erfolgen in Kürze
                  </li>
                </ul>
                */}
              </div>
            </div>
            <div className="btn" onClick={onBtnInfoClick}>
              Weiter
            </div>
          </>
        );
      };

      const RenderNotificationPage = () => {
        if (isOverBooked) {
          return (
            <div className="modal-confirmation-info">
              <p>Vielen Dank für Ihre Anmeldung.</p>
              <p>
                Die Veranstaltung ist derzeit ausgebucht. Sie wurden auf die
                Warteliste gesetzt und erhalten eine Benachrichtigung, sobald
                ein Platz frei wird.
              </p>
              <div className="btn" onClick={onBtnInfoClick}>
                Schließen
              </div>
            </div>
          );
        }

        return (
          <div className="modal-confirmation-info">
            <p>Herzlichen Dank für ihre Anmeldung.</p>
            <p>
              Hiermit bestätigen wir Ihre Teilnahme an der 5. MiWi Lausitz am
              25. März 2026 ab 14:30 Uhr. Die Veranstaltung findet im Hotel &
              Restaurant "Zur Waldhufe" in Doberlug-Kirchhain statt.
            </p>
            <p>
              Sollte diese Anmeldung irrtümlich erfolgt sein, teilen Sie uns
              dies bitte umgehend unter veranstaltung@an-sb.de mit.
            </p>
            <div className="btn" onClick={onBtnInfoClick}>
              Schließen
            </div>
          </div>
        );
      };

      switch (activePageIndex) {
        case 0:
          return setActivePage(RenderInfoPage());

        case 1:
          return setActivePage(
            <EventForm AfterSubmitAction={onBtnInfoClick} />,
          );

        case 2:
          return setActivePage(RenderNotificationPage());

        default:
          return setActivePage(<></>);
      }
    },
    [activePageIndex],
  );

  return (
    <div className="modal">
      <span className="modal-btn-close">
        <img src={closeBtnIcon} alt="anmelde_icon" onClick={closeModal} />
      </span>
      <div className="modal-event-body">{activePage}</div>
    </div>
  );
}

export default EventModal;
